import { Layout } from './layout';

Layout.displayName = 'Typography';

export { Layout as Typography };

export { Weight as TypographyWeight, Level as TypographyLevel } from './enums';

export type { ExternalProps as TypographyProps } from './types';
